function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1953 2.09375H11.9375V1.4375C11.9375 1.19589 11.7416 1 11.5 1C11.2584 1 11.0625 1.19589 11.0625 1.4375V2.09375H4.9375V1.4375C4.9375 1.19589 4.74164 1 4.5 1C4.25836 1 4.0625 1.19589 4.0625 1.4375V2.09375H2.80469C1.80957 2.09375 1 2.90332 1 3.89844V13.1953C1 14.1904 1.80957 15 2.80469 15H13.1953C14.1904 15 15 14.1904 15 13.1953V3.89844C15 2.90332 14.1904 2.09375 13.1953 2.09375ZM2.80469 2.96875H4.0625V3.40625C4.0625 3.64786 4.25836 3.84375 4.5 3.84375C4.74164 3.84375 4.9375 3.64786 4.9375 3.40625V2.96875H11.0625V3.40625C11.0625 3.64786 11.2584 3.84375 11.5 3.84375C11.7416 3.84375 11.9375 3.64786 11.9375 3.40625V2.96875H13.1953C13.708 2.96875 14.125 3.3858 14.125 3.89844V7H1.875V3.89844C1.875 3.3858 2.29205 2.96875 2.80469 2.96875ZM13.1953 14.125H2.80469C2.29205 14.125 1.875 13.708 1.875 13.1953V8H14.125V13.1953C14.125 13.708 13.708 14.125 13.1953 14.125Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.7
});
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    color: "#D18F1F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.63e9d2ac7ff7950e0e591ddd96132d77.svg";
export { ForwardRef as ReactComponent };